// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "label.required:before {\n  content: \"* \";\n  color: #D22F27;\n}\niframe {\n  width: 100% !important;\n}\n.field-required:before {\n  content: \"* \";\n  color: #D22F27;\n}\n.otp-wrapper {\n  width: 300px;\n}\n.edit-phone-number {\n  min-height: 200px;\n}", ""]);
// Exports
module.exports = exports;
